import React, { useState } from "react";
import { FaPen, FaPlus, FaPrint, FaTrash } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import ActivityIndicator from "../../../../components/ActivityIndicator";

import Card from '../../../../components/Card';
import CardItem from '../../../../components/CardItem';
import PopupReports from "../../../../components/PopupReports";
import costCenterServices from "../../../../services/admFin/costCenterServices";
import reportServices from "../../../../services/reportServices";
import { CostCenterInfoPopUp } from "./CostCenterInfoPopUp";
import CostCenterPopUp from "./CostCenterPopUp";


export default function CostCentersCard(props) {
    const [visibility, setVisibility] = useState(false);
    const [visibilityInfo, setVisibilityInfo] = useState(false);
    const [visibilityEdit, setVisibilityEdit] = useState(false);
    const [visibilityReport, setVisibilityReport] = useState(false);
    const [costCenterInfo, setCostCenterInfo] = useState({});
    const [showElements, setShowElements] = useState(false);

    const costCenters = props.costCenters;

    async function createCostCenter(costCenter) {
        if (costCenter.nome.length < 1) {
            alert("O nome do centro de custo não pode estar vazio");
            return;
        }
        try {
            const response = await costCenterServices.postCostCenter(costCenter.nome);
            props.setCostCenters(oldArray => {
                const temp = [...oldArray];
                temp.push(response.data);
                return temp;
            })
            setVisibility(false);
        } catch (err) {
            alert("Não foi possível criar o centro de custo")
        }
    }

    async function editCostCenter(costCenter) {
        if (costCenter.nome.length < 1) {
            alert("O nome do centro de custo não pode estar vazio");
            return;
        }
        try {
            const response = await costCenterServices.patchCostCenter(costCenterInfo.id, costCenter.nome);
            props.setCostCenters(oldArray => {
                return oldArray.map(obj => {
                    if (obj.id === costCenterInfo.id)
                        return response.data;
                    else
                        return obj;
                })
            })
            setVisibilityEdit(false);
        } catch (err) {
            alert("Não foi possível editar o centro de custo")
        }
    }

    function generateReport(fields = null, fileName) {
        console.log(fields);
        try {
            reportServices.generateReportRecords(costCenters, "RELATÓRIO DE CENTROS DE CUSTO",fields, fileName);
        } catch (err) {
            alert(err.message);
            return false;
        }
    }


    return (
        <Card
            tittle={props.tittle}
            options={
                <>
                    <button onClick={() => setVisibility(!visibility)} className="records-new-item-button"><FaPlus /></button>
                    <CostCenterPopUp
                        tittle="Novo Centro de Custo"
                        buttonTittle="Criar"
                        visibility={visibility}
                        setVisibility={setVisibility}
                        onClick={createCostCenter}
                    />
                    <button title="Relatório" onClick={() => setVisibilityReport(true)} className="records-new-item-button"><FaPrint/></button>
                    <PopupReports
                        visibility={visibilityReport}
                        setVisibility={setVisibilityReport}
                        tittle={`Relatório de Centros de Custo`}
                        fields={reportServices.recordFields}
                        generateReport={generateReport}
                    />
                    <button
                        onClick={() => setShowElements(!showElements)}
                        className={"records-hide-elements-button" + (showElements ? " showing" : "")}
                    >
                        <IoIosArrowDown />
                    </button>
                </>
            }
        >
            {
                !showElements ?
                    null
                    :
                    <div className="records-elements">
                        {
                            costCenters && costCenters.length ?
                            <>
                            <CostCenterPopUp
                                tittle="Centro de Custo"
                                buttonTittle="Editar"
                                visibility={visibilityEdit}
                                setVisibility={setVisibilityEdit}
                                onClick={editCostCenter}
                                costCenter={costCenterInfo}
                            />

                            <CostCenterInfoPopUp
                                visibility={visibilityInfo}
                                setVisibility={setVisibilityInfo}
                                costCenter={costCenterInfo}
                            />
                            {

                                costCenters.map((costCenter) =>
                                    <div className="records-element-container"  key={costCenter.id}>
                                        <div onClick={() => {
                                            setCostCenterInfo(costCenter);
                                            setVisibilityInfo(true);
                                        }}>
                                            <CardItem
                                                removeLeftSpace
                                                bodyOptions={<span className="tag">COD {costCenter.id}</span>}
                                            >
                                                <h4>
                                                    {costCenter.nome}
                                                </h4>
                                            </CardItem>
                                        </div>
                                        <button onClick={() => {
                                            setCostCenterInfo(costCenter);
                                            setVisibilityEdit(true);
                                        }}>
                                            <FaPen />
                                        </button>
                                        <button className="red" onClick={() => props.deleteElement(costCenter.id, costCenterServices.deleteCostCenter, props.setCostCenters)}>
                                            <FaTrash />
                                        </button>
                                    </div>
                                )
                            }
                            </>
                            :
                            <ActivityIndicator />
                        }
                    </div>
            }
        </Card>
    )
}